/**
 * Controls the functionality of the search toggle menu item.
 *
 */

const searchToggle = {
	init: function() {
		document.addEventListener( 'DOMContentLoaded', searchToggle.setupListener );
	},

	setupListener: function () {
		let toggleController = searchToggle.toggleController();

		if ( !toggleController ) {
			return false;
		}

		toggleController.addEventListener( 'click', searchToggle.clickHandler );
	},

	clickHandler: function( event ) {
		event.preventDefault();
		let searchForm = searchToggle.searchForm();
		let searchField = searchForm.querySelector( '.search-field' );

		// If the search form is already active and text is entered, submit form
		if ( searchField.value !== '' && searchForm.classList.contains( '--active' ) ) {
			return searchForm.submit();
		}

		// Toggle the visibility of the search form
		return searchForm.classList.toggle( '--active' );
	},

	toggleController: function() {
		return document.querySelector( '#js-search-toggle' );
	},

	searchForm: function() {
		return document.querySelector( '.search-form' );
	}
};

export default searchToggle;
